<div class="lot-history" [nbSpinner]="this.isLoading">
  <div class="section-head">
    <fa-icon [icon]="faSitemap" class="section-icon"></fa-icon>
    <h3>{{"Lot" | tenantWords}} History</h3>
  </div>
  <ejs-diagram #diagram id="diagram" width="100%" height="500px"
    [nodes]="nodes" [connectors]="connectors"
    [getNodeDefaults]="getNodeDefaults" [getConnectorDefaults]="getConnectorDefaults"
    [snapSettings]="snapSettings">
  </ejs-diagram>
</div>
